/* eslint-disable no-console */
const isProductionEnvironment = () => {
    const hostname = (global.location && global.location.hostname) || 'default';
    return hostname.includes('www.xing.com');
};
export const Logger = (function () {
    return {
        log: function (...objects) {
            if (!isProductionEnvironment()) {
                console.debug(...objects);
            }
        },
    };
})();
//# sourceMappingURL=logger.js.map